import { IconButtonProps, IconButton as MuiIconButton } from '@mui/material'
import { To, useNavigate } from 'react-router-dom'

type Props = IconButtonProps & {
    href?: To
}

export default function IconButton(props: Props) {
    const navigate = useNavigate()
    const { href, ...rest } = props

    if (href) {
        return (
            <MuiIconButton
                {...rest}
                onClick={e => {
                    props.onClick?.(e)
                    navigate(href)
                }}
            />
        )
    }

    return <MuiIconButton {...rest} />
}
